import PropTypes from 'prop-types';

const CheckBox = ({
  id,
  value,
  onChange,
  label,
  className,
  labelClass,
  error,
  errorMsg,
}) => (
  <>
    <div className={className || ''}>
      <input
        className={`cef-ui-checkbox__input ${
          error && 'cef-ui-checkbox__input--danger'
        }`}
        type="checkbox"
        id={id}
        name={id}
        value={value}
        checked={value}
        onChange={() => onChange()}
      />
      <label
        htmlFor={id}
        className={`mb-0 ${labelClass || ''}`}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    </div>
    {error && (
      <p className="mb-0 mt-0 cef-ui-input__error cef-ui-input-error">
        {errorMsg}
      </p>
    )}
  </>
);

CheckBox.propTypes = {
  id: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
  labelClass: PropTypes.string,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
};

export default CheckBox;
